// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"b0e6c991","787":"1ed0c42c","807":"67d6e2fc"}[chunkId] + ".chunk.js";
};